import { useContext } from 'react';
import { AuthContext } from '../AuthContext';
import { showErrorToast } from '../utils/toastUtils';

const ProtectedRoute = ({ children, requireAdmin }) => {
    const { isInitializing, isAdmin } = useContext(AuthContext);

    // Show nothing while checking authentication state
    if (isInitializing) {
        return null;
    }

    // If admin is required and user is not admin, show error toast
    if (requireAdmin && !isAdmin) {
        showErrorToast('You do not have permission to access this page');
        return null;
    }

    return children;
};

export default ProtectedRoute; 